import React from "react";
import { Formik, FormikProps } from "formik";
import { Col, Row } from "react-bootstrap";
// import { v4 as uuidv4 } from 'uuid'
import ButtonComponent from "../button";
import {
  ContainerForm,
  ContentFields,
  CountNumber,
  FormikStyled,
  LabelGroupStyled,
} from "./styled";

import { getInitialValues, getValidationSchema, GroupProp } from "./utils/util";
import MakeField from "./MakeField";
import { theme } from "../../styles/theme";

type FormProps = {
  groups: GroupProp[];
  enbaleCountGroup?: boolean;
  button: {
    submit: string;
    submitting: string;
    hide?: boolean;
    backgroundColor?: string;
    color?: string;
  };
  backButton?: {
    submit: string;
    submitting: string;
    hide?: boolean;
    backgroundColor?: string;
    color?: string;
    onClick?: () => void;
  };
  onSubmit: (values: any, actions: any) => void;
  className?: string;
  enableReinitialize?: boolean;
  innerRef?: React.Ref<FormikProps<any>>;
};

function FormFactory({
  groups,
  button,
  onSubmit,
  className,
  enbaleCountGroup,
  backButton,
  innerRef,
  enableReinitialize = true,
}: FormProps): JSX.Element {
  const validationSchema = getValidationSchema(groups.filter((el) => !el?.hide));
  const initialValues = getInitialValues(groups.filter((el) => !el?.hide));

  return (
    <Formik
      innerRef={innerRef}
      enableReinitialize={enableReinitialize}
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={(values, actions) => {
        onSubmit(values, actions);
      }}>
      {({
        handleChange,
        handleBlur,
        // handleSubmit,
        setFieldValue,
        errors,
        isValid,
        values,
        isSubmitting,
      }: FormikProps<any>) => (
        <FormikStyled id="form-factory" className={className}>
          <Row className="w-100 h-auto m-0 row-container">
            {groups
              .filter((el) => !el?.hide)
              .map((group, i) => (
                <React.Fragment key={group.groupName}>
                  {group.groupLabel && (
                    <LabelGroupStyled>
                      {enbaleCountGroup && (
                        <CountNumber className="count-label">
                          {i + 1}
                        </CountNumber>
                      )}
                      {group.groupLabel}
                    </LabelGroupStyled>
                  )}
                  <ContainerForm
                    key={group.groupName}
                    className="container-form row">
                    {group.items.map(
                      (field, index) =>
                        !field?.hide && (
                          <Col
                            xs={field?.col?.xs || 12}
                            md={field?.col?.md || 12}
                            lg={field?.col?.lg || 12}
                            key={`${field?.name}`}
                            className={`${field?.name}`}>
                            <ContentFields>
                              <MakeField
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${index}-${field?.name}`}
                                field={field}
                                errors={errors}
                                handleChange={handleChange}
                                handleCustomChange={field?.onChange}
                                handleBlur={handleBlur}
                                setFieldValue={setFieldValue}
                                formValues={values}
                              />
                            </ContentFields>
                          </Col>
                        )
                    )}
                  </ContainerForm>
                </React.Fragment>
              ))}
          </Row>
          <div className="button-box">
            {!backButton?.hide && backButton && (
              <ButtonComponent
                type="button"
                title={
                  isSubmitting
                    ? backButton?.submitting || "Enviando..."
                    : backButton?.submit || "Enviar"
                }
                color={backButton?.color || theme.colors.white}
                backgroundColor={
                  backButton?.backgroundColor || theme.colors.primary
                }
                disabled={isSubmitting && isValid}
                onClick={backButton.onClick}
              />
            )}
            {!button?.hide && (
              <ButtonComponent
                type="submit"
                title={
                  isSubmitting
                    ? button.submitting || "Enviando..."
                    : button.submit || "Enviar"
                }
                color={button?.color || theme.colors.white}
                backgroundColor={
                  button?.backgroundColor || theme.colors.primary
                }
                disabled={isSubmitting || !isValid}
              />
            )}
          </div>
        </FormikStyled>
      )}
    </Formik>
  );
}

export default FormFactory;
